// extracted by mini-css-extract-plugin
export default {"integration_card":"integration_integration_card__fTQlk","connect_btn":"integration_connect_btn__TfJ0a","integration_icon":"integration_integration_icon__HdTuI"};